export default __webpack_public_path__ + "img/component-profile-card.5e070d7a.jpg";